import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartLines = ({chartData, title}) => {
  if (chartData == undefined || chartData.length == 0) {
      return
  }

  //선그래프
  const optionsLine = {
    title: {
      text: title,
      style: {
        color: '#000',
        fontSize: "14px",
        fontWeight: "bold",
      }
    },
    series: chartData,
    yAxis: {
      title: {
        text: '매출액'
      },
    },
    xAxis: {
      type: 'category',
      categories: chartData[0].cat
    },
    accessibility: {
      enabled: false
    },
  }

  return (
    <>
      <HighchartsReact highcharts={Hightcharts}
        options={optionsLine}
      />
    </>
  );
};

export default ChartLines;